/**
 * Task HS: owner app 员工业绩 redesign (cards, sort, search, summary) + staff detail (/checkout/hq/staff/:id).
 * One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts.
 */
const ROWS = [
  ["hs.title","Staff performance","员工业绩"],
  ["hs.period.custom","Custom","自定义"],
  ["hs.from","From","开始"],
  ["hs.to","To","结束"],
  ["hs.apply","Apply","确定"],
  ["hs.branch","Branch","分店"],
  ["hs.sum.sales","Total sales","总销售额"],
  ["hs.sum.commission","Total commission","总提成"],
  ["hs.sum.services","Services","服务次数"],
  ["hs.sum.top","Top performer","业绩第一"],
  ["hs.search","Search staff by name","按姓名搜索员工"],
  ["hs.sort","Sort by","排序"],
  ["hs.sort.sales","Sales","销售额"],
  ["hs.sort.commission","Commission","提成"],
  ["hs.sort.services","Services","服务"],
  ["hs.sort.rebooking","Rebooking","回头率"],
  ["hs.card.commission","Commission","提成"],
  ["hs.card.services","Services","服务"],
  ["hs.card.customers","Customers","顾客"],
  ["hs.card.rebooking","Rebook","回头"],
  ["hs.card.attendance","Days","出勤"],
  ["hs.card.daysN","{n} d","{n} 天"],
  ["hs.card.vsAvg","{pct} vs team avg","比团队平均 {pct}"],
  ["hs.card.atAvg","Team average","团队平均"],
  ["hs.card.open","Open details for {name}","查看 {name} 的详情"],
  ["hs.empty","No staff activity in this period","这段期间没有员工业绩"],
  ["hs.noMatch","No staff match \"{q}\"","没有找到 \"{q}\""],
  ["hs.back","Staff performance","员工业绩"],
  ["hs.kpi.sales","Sales","销售额"],
  ["hs.kpi.commission","Commission","提成"],
  ["hs.kpi.services","Services done","服务次数"],
  ["hs.kpi.customers","Customers served","服务顾客"],
  ["hs.kpi.newReturning","{new} new · {ret} returning","新客 {new} · 回头客 {ret}"],
  ["hs.kpi.avgTicket","Average ticket","平均客单价"],
  ["hs.kpi.orders","{n} sales","{n} 单"],
  ["hs.kpi.rebooking","Rebooking","回头预约率"],
  ["hs.kpi.rebookedOf","{n} of {total} customers","{total} 位顾客中 {n} 位"],
  ["hs.kpi.tips","Tips","小费"],
  ["hs.kpi.refunds","Refunds / voids","退款 / 作废"],
  ["hs.kpi.refundsLine","{n} refunded · {v} voided","退款 {n} · 作废 {v}"],
  ["hs.salesBy","Sales by type","销售构成"],
  ["hs.s.services","Services","服务"],
  ["hs.s.products","Products","零售产品"],
  ["hs.s.packagesSold","Packages sold","配套销售"],
  ["hs.s.packageRedeem","Package redeem","配套使用"],
  ["hs.s.storedValue","Stored value","储值"],
  ["hs.s.subscriptions","Subscriptions","订阅"],
  ["hs.commBy","Commission by source","提成来源"],
  ["hs.c.service","Services","服务"],
  ["hs.c.product","Retail","零售"],
  ["hs.c.packageSale","Package sales","配套销售"],
  ["hs.c.packageRedemption","Package use","配套使用"],
  ["hs.c.storedValue","Stored value","储值"],
  ["hs.c.subscription","Subscriptions","订阅"],
  ["hs.c.total","Total commission","提成合计"],
  ["hs.trend","Daily sales","每日销售额"],
  ["hs.trendWeekly","Weekly sales","每周销售额"],
  ["hs.trendEmpty","No sales in this period","这段期间没有销售"],
  ["hs.topServices","Top services","热门服务"],
  ["hs.topProducts","Top products","热门产品"],
  ["hs.timesN","×{n}","×{n}"],
  ["hs.none","Nothing yet","暂无"],
  ["hs.att","Attendance","出勤"],
  ["hs.att.days","Days worked","出勤天数"],
  ["hs.att.hours","Hours","工时"],
  ["hs.att.late","Late","迟到"],
  ["hs.att.lateLine","{n}× · {m} min","{n} 次 · {m} 分钟"],
  ["hs.att.leave","Leave taken","请假"],
  ["hs.att.leaveDays","{n} d","{n} 天"],
  ["hs.att.pending","{n} pending","{n} 个待批"],
  ["hs.att.shifts","Shifts","班次"],
  ["hs.att.shiftsLine","{n} clocked · {s} rostered","打卡 {n} · 排班 {s}"],
  ["hs.att.off","Attendance tracking is not switched on for this shop.","本店未开启考勤功能。"],
  ["hs.att.lateMin","late {m} min","迟到 {m} 分钟"],
  ["hs.att.noOut","no clock-out","未下班打卡"],
  ["hs.att.showAll","Show all {n}","显示全部 {n} 条"],
  ["hs.leave.pending","Pending","待批"],
  ["hs.leave.half","½ day","半天"],
  ["hs.recent","Recent sales","最近销售"],
  ["hs.walkIn","Walk-in","散客"],
  ["hs.refunded","Refunded","已退款"],
  ["hs.subs","Subscriptions they look after","负责的订阅"],
  ["hs.subs.count","Subscribers","订阅顾客"],
  ["hs.subs.mrr","Monthly recurring","每月经常性收入"],
  ["hs.subs.pastDue","{n} payment failed","{n} 个付款失败"],
  ["hs.sub.past_due","Payment failed","付款失败"],
  ["hs.sub.unpaid","Unpaid","未付款"],
  ["hs.sub.paused","Paused","已暂停"],
  ["hs.sub.trialing","Trial","试用中"],
  ["hs.pkgSold","Packages sold","售出配套"],
  ["hs.pkgSoldLine","{n} sold","售出 {n} 个"],
  ["hs.order.title","Sale {label}","销售单 {label}"],
  ["hs.order.readOnly","Read-only","只读"],
  ["hs.order.subtotal","Subtotal","小计"],
  ["hs.order.discount","Discount","折扣"],
  ["hs.order.total","Total","总计"],
  ["hs.order.refunded","Refunded","已退款"],
  ["hs.order.balance","Balance due","未付"],
  ["hs.order.payments","Payments","付款"],
  ["hs.order.voided","Voided","已作废"],
  ["hs.pay.cash","Cash","现金"],
  ["hs.pay.external_card","Card","刷卡"],
  ["hs.pay.bank_transfer","Bank transfer","银行转账"],
  ["hs.pay.stripe","Online card","线上银行卡"],
  ["hs.pay.credit","Stored value","储值"],
  ["hs.multiCurrency","Branches in other currencies are shown in their own currency.","不同币种的分店按各自币种显示。"],
] as const;

export type HsKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<HsKey, string>;

export const taskHS = { en: col(1), zh: col(2), ms: col(1) };
